import React from 'react';

const ToggleButtonContainer: React.FC = ({ children }) => {
  return <div className="flex items-center w-auto h-12">{children}</div>;
};

export default ToggleButtonContainer;
